import { render, staticRenderFns } from "./ConfirmCreateBoccoChannelModal.vue?vue&type=template&id=502b362b&scoped=true&"
import script from "./ConfirmCreateBoccoChannelModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmCreateBoccoChannelModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmCreateBoccoChannelModal.vue?vue&type=style&index=0&id=502b362b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502b362b",
  null
  
)

export default component.exports